import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=501fe498&scoped=true&"
import script from "@/scripts/administrator/department/department.js?vue&type=script&lang=js&"
export * from "@/scripts/administrator/department/department.js?vue&type=script&lang=js&"
import style0 from "./Department.vue?vue&type=style&index=0&id=501fe498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fe498",
  null
  
)

export default component.exports